import { render, staticRenderFns } from "./OfficeMonitorSettings.vue?vue&type=template&id=7f77e2ba&scoped=true&lang=pug&"
import script from "./OfficeMonitorSettings.vue?vue&type=script&lang=js&"
export * from "./OfficeMonitorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f77e2ba",
  null
  
)

export default component.exports